import "./LoginBoxLoggedIn.scss";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Dialog } from "spot-component-library/src/components/basic/dialog/Dialog";
import { SPOTButton } from "spot-component-library/src/components/SPOTButton";
import FormatNumber from "../../components/FormatNumber";
import { BalanceResponse } from "../../types/BalanceResponse";

interface LoginBoxLoggedInProps {
    debtNumber: string;
    balanceResponse: BalanceResponse;
    buttonLinkUrl: string;
    onLogout: () => void;
}

export const LoginBoxLoggedIn: React.FC<LoginBoxLoggedInProps> = ({ debtNumber, balanceResponse, buttonLinkUrl, onLogout }) => {
    const { t } = useTranslation();
    const isBalanceVisible = getBalanceVisible(balanceResponse);

    return (
        <div id="activeLogin">
            <div className="infoBox">
                <Dialog closeIcon={true} triggerIcon="icon-info" dialogStyle={{ maxWidth: "600px", width: "85%" }}>
                    <p>
                        <Trans i18nKey="INSTRUCTION_PAGE.PREFIX.CONTENT" components={{ a: <a /> }}>
                            {t("LOGIN_BOX.LOGIN.DIALOG_TEXT")}
                        </Trans>
                    </p>
                </Dialog>
            </div>
            <h2>{t("LOGIN_BOX.LOGIN.HEADLINE")}</h2>
            <div className="debtAndBalanceBlock">
                <p>
                    {t("LOGIN_BOX.LOGIN.DEBTNO")}
                    <span> {debtNumber}</span>
                </p>
                <p>
                    <div className="infoBoxAmount">
                        <Dialog closeIcon={true} triggerIcon="icon-info" dialogStyle={{ maxWidth: "600px", width: "85%" }}>
                            <p>
                                <Trans i18nKey={t("LOGIN_BOX.LOGIN.DIALOG_DEBTNO")} />
                            </p>
                        </Dialog>
                    </div>
                    {t("LOGIN_BOX.LOGIN.BALANCE")}
                    {isBalanceVisible && (
                        <span>
                            <FormatNumber number={balanceResponse.amount} /> {balanceResponse.currencyCode}
                        </span>
                    )}
                </p>
            </div>
            <div>
                <SPOTButton label={t("LOGIN_BOX.LOGIN.BUTTON")} type="primary" backgroundColor="black" onClick={() => (window.location.href = buttonLinkUrl)} />
            </div>
            <div>
                <p
                    className="deleteLink"
                    onClick={onLogout}
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            onLogout();
                        }
                    }}>
                    {t("LOGIN_BOX.LOGIN.DELETE")}
                </p>
            </div>
        </div>
    );
};

export function getBalanceVisible(balanceResponse: BalanceResponse) {
    return balanceResponse.amount !== undefined;
}
